interface Props {
  asLink: boolean;
  articleThumbnailSrc: string;
  asFullWidth?: boolean;
  articleLink?: string;
  articleTitle?: string;
}

export const Thumbnail = ({ asLink, articleLink, articleThumbnailSrc, articleTitle, asFullWidth = false }: Props) => {
  return asLink ? (
    <a href={articleLink} target="_blank" rel="noreferrer" data-skip-tracking="true">
      <img src={articleThumbnailSrc} alt={articleTitle} className={!asFullWidth ? 'sm:max-h-56 sm:max-w-56' : ''} />
    </a>
  ) : (
    <img src={articleThumbnailSrc} alt={articleTitle} className={!asFullWidth ? 'sm:max-h-56 sm:max-w-56' : ''} />
  );
};
